import React from "react";
import PropTypes from "prop-types";
import { Circle, HStack, Heading, Text, VStack, Box } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

function Feature({ icon, iconBg, heading, text }) {
  return (
    <MotionBox
      whileHover={{
        y: -8,
        transition: { duration: 0.3, ease: "easeOut" }
      }}
    >
      <HStack
        align="start"
        spacing="1.6rem"
        maxW="320px"
        p={6}
        borderRadius="xl"
        bg="white"
        boxShadow="sm"
        border="1px solid"
        borderColor="gray.100"
        transition="all 0.3s ease"
        _hover={{
          boxShadow: "xl",
          borderColor: "gray.200",
        }}
        h="full"
      >
        <motion.div
          whileHover={{
            rotate: [0, -10, 10, -10, 0],
            transition: { duration: 0.5 }
          }}
        >
          <Circle size="3.75rem" bg={iconBg} color="white" boxShadow="md">
            {icon({ size: "1.5rem" })}
          </Circle>
        </motion.div>
        <VStack align="start" spacing="0.75rem">
          <Heading as="h3" size="md" pt="0rem" color="gray.900">
            {heading}
          </Heading>
          <Text color="gray.600" lineHeight="1.6" fontSize="sm">
            {text}
          </Text>
        </VStack>
      </HStack>
    </MotionBox>
  );
}

Feature.propTypes = {
  icon: PropTypes.func.isRequired,
  iconBg: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Feature;
